import {pushNotification} from '@malt/joy-entrypoint/src/js/notification';

Hop.defineModule('group-invitation-modal', (root, param) => {
    const $root = $(root);
    const companyName = param.companyName ? param.companyName : root.getAttribute('data-company-name');

    const $modal = $root;
    const $inviteForm = $root.find('form');
    const $addInviteRow = $root.find('#addInviteRow');
    const $inviteRowsContainer = $root.find('#additionnalInviteRows');
    const $seeSentInvitationsLink = $('#seeSentInvitations');
    const $hiddenWhenGroupInvite = $root.find('[data-toBeHiddenWhenGroupInvite]');
    const $groupInviteToggle = $root.find('#groupInviteToggle');
    const $groupInviteForm = $root.find('#groupInviteForm');
    const INVITE_ROW_TPL = $('#inviteRowTemplate').html();
    const GROUP_INVITE_TPL = $('#groupInviteTemplate').html();

    let settings;
    let htmlInvite;
    let htmlGroup;

    // ADD AND REMOVE INVITES ROWS -------------------------------------------------
    function reOrderRowsIndexes(removedRow) {
        const nextAllRows = removedRow.nextAll('.inviteRow');
        const removedRowIdx = parseInt(removedRow.attr('data-rowIdx'));
        let newIdx;
        const attributesToBeUpdated = ['for', 'id', 'name'];

        function getAttrWithNewIdx(attr, idx) {
            return attr.replace(/(?:\[\d\])/, '[' + idx + ']');
        }

        function replaceAttrIdx($el, attr, idx) {
            if ($el.attr(attr)) {
                $el.attr(attr, getAttrWithNewIdx($el.attr(attr), idx));
            }
        }

        function updateAllAttributesInRow(row, newIdx) {
            row.attr('data-rowIdx', newIdx);
            row.find('input , select , label').each((idx, el) => {
                const $el = $(el);
                attributesToBeUpdated.forEach((attr) => {
                    replaceAttrIdx($el, attr, newIdx);
                });
            });
        }

        nextAllRows.each((idx, el) => {
            newIdx = removedRowIdx + idx;
            updateAllAttributesInRow($(el), newIdx);
        });
    }

    function addInviteRow(idx) {
        settings = {rowIdx: idx};
        htmlInvite = Hop.template(INVITE_ROW_TPL, {variable: 'm'})(settings);

        $inviteRowsContainer.append(htmlInvite);
    }

    function removeInviteRow($rowToBeRemoved) {
        reOrderRowsIndexes($rowToBeRemoved);
        $rowToBeRemoved.remove();
    }

    function removeAllAdditionnalRows() {
        $inviteRowsContainer.html('');
    }

    function isRowEmpty(rowsIdx) {
        const emptyMail = $('input[name="invitations[' + rowsIdx + '].email"]').val().length === 0 ? true : false;
        const emptyFirstName = $('input[name="invitations[' + rowsIdx + '].firstName"]').val().length === 0 ? true : false;
        const emptyLastName = $('input[name="invitations[' + rowsIdx + '].lastName"]').val().length === 0 ? true : false;
        return emptyMail && emptyFirstName && emptyLastName;
    }

    function removeEmptyAdditionnalRows() {
        $inviteRowsContainer.find('.inviteRow').each((idx, el) => {
            const $el = $(el);
            if (isRowEmpty($el.attr('data-rowIdx'))) {
                removeInviteRow($el);
            }
        });
    }

    // GROUP INVITE --------------------------------------------------------------

    function toggleGroupSubmitState(emptyField) {
        $('#groupSubmit').prop('disabled', emptyField);
    }

    function showGroupInvite() {
        $hiddenWhenGroupInvite.css('display', 'none');
        htmlGroup = Hop.template(GROUP_INVITE_TPL, {})();
        $groupInviteForm.html(htmlGroup);
    }

    function hideGroupInvite() {
        $hiddenWhenGroupInvite.css('display', 'block');
        $('#groupInviteForm').html('');
    }

    function getSplitEmails(emailsValue) {
        emailsValue = emailsValue.replace(/\s+/g, ''); // clean whitespace
        return emailsValue.split(/,|;/);
    }

    function addGroupInviteRows(emailsValue) {
        removeEmptyAdditionnalRows();
        const mails = getSplitEmails(emailsValue);
        let emailField;
        mails.forEach((email) => {
            if (isRowEmpty(0)) {
                $('input[name="invitations[0].email"]').val(email);
            } else {
                const rowIdx = $root.find('.inviteRow').length;
                addInviteRow(rowIdx);
                emailField = $root.find('.inviteRow')[rowIdx].querySelector('input[type="email"]');
                emailField.value = email;
            }
        });
    }

    function readEmailsFromForm() {
        return (
            $inviteForm
                .find('input[type="email"]')
                .get()
                // generic code in case of email inputs having the "multiple" attribute set to true
                .map((el) => el.value.trim().split(/\s*,\s*/))
                .reduce((acc, val) => acc.concat(val), [])
                .filter((val) => !!val)
        );
    }

    // GLOBAL HANDLERS -------------------------------------------------------------
    function setHandlers() {
        $addInviteRow.on('click', (e) => {
            e.preventDefault();
            const rowIdx = $root.find('.inviteRow').length;
            addInviteRow(rowIdx);
        });

        $groupInviteToggle.on('click', (e) => {
            e.preventDefault();
            showGroupInvite();
        });

        $(document).on('click', '#groupSubmit', () => {
            addGroupInviteRows($('#groupInviteField').val());
            hideGroupInvite();
        });

        $(document).on('input', '#groupInviteField', (e) => {
            const empty = e.target.value.length === 0 ? true : false;
            toggleGroupSubmitState(empty);
        });

        $(document).on('click', '.removeInviteRow', (e) => {
            const $rowToBeRemoved = $(e.target).parents('.inviteRow');
            removeInviteRow($rowToBeRemoved);
        });

        $(document).on('click', '#groupCancel', (e) => {
            e.stopPropagation();
            hideGroupInvite();
        });

        const displayConfirmation = (sentEmails) => {
            const emailsHtml = sentEmails.join(', ');
            const message = Hop.message('client.invitation.success.message', companyName, emailsHtml);
            pushNotification(message, {level: 'success'});
        };

        const onSubmitSuccess = (sentEmails) => {
            $seeSentInvitationsLink.removeClass('hidden');

            if (param.displayConfirmation) {
                $modal.one('hidden.bs.modal', () => displayConfirmation(sentEmails));
            }

            $modal.modal('hide');

            if (
                param.reloadPage ||
                // dirty hack for now, for header-v2
                window.location.pathname.match('company/.*/members(/invitations)?$')
            ) {
                window.location.reload();
            }
        };

        $inviteForm.submit((e) => {
            e.preventDefault();

            if (!e.target.checkValidity()) {
                return;
            }

            // read before form is reset
            const emails = readEmailsFromForm();

            const form = $inviteForm[0];
            Hop.post(form.action, new FormData(form)).then(() => onSubmitSuccess(emails));
        });

        $modal.on('hidden.bs.modal', () => {
            removeAllAdditionnalRows();
        });
    }

    setHandlers();
});
